import {
  TextV2,
  SvgMultipleUsers2Bold,
  DetailsHeader,
} from '@insights-ltd/design-library/components';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import { styled } from '@mui/material';
import Grid from '@mui/material/Grid';
import { TeamResponse } from 'api';
import TeamsList from 'pages/Learners/TeamsTab/TeamsList/TeamsList';
import { useTranslation } from 'react-i18next';

const StyledP = styled(TextV2)(() => ({
  marginLeft: '0',
  paddingLeft: '0',
}));

export const LearnerTeamsList = ({
  learnerTeams,
}: {
  learnerTeams?: TeamResponse[];
}) => {
  const { t } = useTranslation();
  const heading = learnerTeams?.length
    ? t('ui.event-management.learner.teams', {
        count: learnerTeams?.length ?? 0,
      })
    : t('ui.event-management.learner.teams.section-heading.no-result');
  return (
    <Grid
      container
      spacing={2}
      sx={{
        ml: 0,
      }}
    >
      <Grid
        sx={() => ({
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          paddingLeft: '0 !important',
        })}
        size={12}
      >
        <DetailsHeader
          Icon={SvgMultipleUsers2Bold}
          text={heading}
          fullWidth
          id="learner-teams-info"
        />
      </Grid>
      {learnerTeams?.length ? (
        <Grid
          size={12}
          sx={{
            pl: 1,
          }}
        >
          <TeamsList
            teamsResponse={learnerTeams}
            alwaysShowControls={false}
            allowDelete={false}
          />
        </Grid>
      ) : (
        <Grid sx={(theme) => ({ marginTop: theme.spacing(spacingSizeMap.M) })}>
          <StyledP color="textSecondary" variant="bodyBold">
            {t('ui.event-management.learner.teams.no-result')}
          </StyledP>
        </Grid>
      )}
    </Grid>
  );
};
